<template>
<div class="text-center d-flex col-lg-8" style="margin-left:auto; margin-right:auto; display:inline-flex; justify-content:center" v-if="checkMobile">
    <h2 class="span alert alert-danger">The website is optimized for desktop use and offers the best user experience when accessed on a desktop computer.</h2>
  </div>
  <footer class="mainFooter">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-3 Hide">
          <div class="footerCol">
            <div class="pmg">
              <img src="@/assets/img/pmlg.png" alt="" />
            </div>
            <div class="aligm-icon">
              <div class="media-icons">
                <a href="https://www.facebook.com/producemartcom"
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <a href="https://www.instagram.com/producemartdotcom/"
                  ><i class="fab fa-instagram"></i
                ></a>
                <!-- <a href="https://twitter.com/producemartcom"
                  ><i class="fab fa-instagram"></i
                ></a> -->
                <a
                  href="https://www.linkedin.com/company/producemart-com/about/?viewAsMember=true"
                  ><i class="fab fa-linkedin-in"></i
                ></a>
                <a
                  href="https://www.youtube.com/channel/UCAH9Y-rOGCljrYMN7JNHO4g/featured"
                  ><i class="fab fa-youtube"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="footerCol">
            <h4>Company</h4>
            <div class="divText">
              <p>
                <router-link to="/about"><a>About Us</a></router-link>
              </p>
            </div>
            <!-- <div class="divText">
              <i class="bi bi-geo-alt"></i> 128 City Road, London, EC1V 2NX
            </div>
            <div class="divText">
              <i class="bi bi-telephone"></i> +2348082268957
            </div>
            <div class="divText">
              <i class="bi bi-globe"></i> www.producemart.com
            </div> -->
          </div>
        </div>
        <!-- <div class="col-md-1"></div> -->
        <div class="col-md-2">
          <div class="footerCol">
            <h4>Resources</h4>
            <!-- <p><router-link to="#"><a>Ebook Download</a></router-link></p>
            <p><router-link to="#"><a>Import Export Guide</a></router-link></p> -->
            <p>
              <router-link to="/blog"><a>Blog</a></router-link>
            </p>
            <p>
              <router-link to="/faq"><a>FAQs</a></router-link>
            </p>
            <!-- <p>
              <router-link to="/supplier-audit"><a>Supplier Audit</a></router-link>
            </p> -->
          </div>
        </div>
        <div class="col-md-2">
          <div class="footerCol">
            <h4>Services</h4>
            <!-- <p><router-link to="/contact"><a>Contact Us</a></router-link></p> -->
            <p>
              <!-- <router-link to="/products"><a>View Products</a></router-link> -->
              <a :href="product" >View Products</a>
            </p>
            <p>
              <!-- <router-link to="/request-a-product"
                ><a>Request A Product</a></router-link
              > -->
              <a :href="requestAProduct" >Request A Product</a>
            </p>
          </div>
        </div>
        <div class="col-md-2">
          <div class="footerCol">
            <h4>Legal</h4>
            <p>
              <router-link to="/terms" target="_blank"><a>Terms & Conditions</a></router-link>
            </p>
            <p>
              <router-link to="/privacy" target="_blank"><a>Privacy Policy</a></router-link>
            </p>
            <p>
              <router-link to="/paia" target="_blank"><a>PAIA Manual</a></router-link>
            </p>
            <!-- <p><router-link to="/cookies"><a>Cookies Policy</a></router-link></p> -->
          </div>
        </div>
        <div class="col-md-3">
          <div class="footerCol mobile">
            <div class="pmg">
              <img src="@/assets/img/pmlg.png" alt="" />
            </div>
            <div class="media-icons">
              <a href="https://www.facebook.com/producemartcom"
                ><i class="fab fa-facebook-f"></i
              ></a>
              <!-- <a href="https://twitter.com/producemartcom"
                ><i class="fab fa-twitter"></i
              ></a> -->
              <a href="https://www.instagram.com/producemartdotcom/"
                ><i class="fab fa-instagram"></i
              ></a>
              <a
                href="https://www.linkedin.com/company/producemart-com/about/?viewAsMember=true"
                ><i class="fab fa-linkedin-in"></i
              ></a>
              <a
                  href="https://www.youtube.com/channel/UCAH9Y-rOGCljrYMN7JNHO4g/featured"
                  ><i class="fab fa-youtube"></i
                ></a>
            </div>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>
    </div>
    <div class="container copyrightFooter">
      <div class="row">
        <div class="col-lg-12 text-center">
          <p>
            Copyright &copy; <span id="autodate"></span>
            ProduceMart. | All Rights Reserved. | Version {{ version() }}
          </p>
        </div>
      </div>
    </div>
  </footer>
 <contact-button></contact-button>
  <ScrollTopArrow></ScrollTopArrow>
</template>
<style scoped src="@/assets/css/styleFrontend.css"></style>
<style scoped src="@/assets/css/bootstrap.css"></style>
<style>
  .footerCol .pmg img {
    width: 80%;
  }
  .media-icons {
    display: flex;
  }
  .Hide {
    display: none;
  }
  @media (max-width: 1299px) {
    .mobile {
      display: none;
    }
    .Hide {
      display: block;
    }
  }
  @media (max-width: 767px) {
    .footerCol .pmg img {
      width: 50%;
      display: block;
      margin: auto;
    }
    .aligm-icon {
      display: block !important;
      margin: auto !important;
      width: 40%;
    }
  }
  @media (max-width: 520px) {
    .aligm-icon {
      display: block !important;
      margin: auto !important;
      width: 50%;
    }
  }
  .media-icons a {
    height: 40px;
    width: 40px;
    margin: 0 8px;
    border-radius: 10%;
    text-align: center;
    line-height: 40px;
    color: #fff;
    font-size: 17px;
    text-decoration: none;
    transition: all 0.4s ease;
  }
  .media-icons a:nth-child(1) {
    background: #fff;
    color: #4267b2 !important;
  }
  .media-icons a:nth-child(1):hover {
    color: #fff !important;
    background: #4267b2;
  }
  /* .media-icons a:nth-child(2) {
    background: #fff;
    color: #1da1f2 !important;
  }
  .media-icons a:nth-child(2):hover {
    color: #fff !important;
    background: #1da1f2;
  } */
  .media-icons a:nth-child(2) {
    color: #e1306c !important;
    background: #fff;
  }
  .media-icons a:nth-child(2):hover {
    color: #fff !important;
    background: #e1306c;
  }
  .media-icons a:nth-child(3) {
    color: #0077b5 !important;
    background: #fff;
  }
  .media-icons a:nth-child(3):hover {
    color: #fff !important;
    background: #0077b5;
  }
  .media-icons a:nth-child(4) {
    color: #c4302b !important;
    background: #fff;
  }
  .media-icons a:nth-child(4):hover {
    color: #fff !important;
    background: #c4302b;
  }
</style>
<script>
  import ScrollTopArrow from "@/components/scrollArrow";
  import contactButton from "@/components/contactButton.vue";
  import {versioning} from "@/util"
  import {zaProducemart} from '@/util/APIroute'
import Swal from "sweetalert2"
  export default {
    components: {
      ScrollTopArrow,
      contactButton
    },
    mounted() {
      //Copyright Date
      function newDate() {
        return new Date().getFullYear();
      }
      document.onload = document.getElementById("autodate").innerHTML =
        newDate();

      this.checkMobile = this.checkMobileFunc()
    },
    watch:{
      checkMobile(){
        if(this.checkMobile){
          Swal.fire({
            title: "Attention: For the best experience, please use a desktop PC!",
            text: "The website is optimized for desktop use and offers the best user experience when accessed on a desktop computer.",
            icon: "info"
          })
        }
      }
    },
    data(){
      return {
        version: versioning,
        checkMobile: false,
        product: zaProducemart + '/products',
        requestAProduct: zaProducemart + '/request-a-product',
      }
    },
    methods:{
      checkMobileFunc(){
        let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
      }
    }
  };
</script>
